import React, { useState, useEffect } from "react";
import PropTypes from "prop-types";
import styled from "@emotion/styled";

// comps
import PeopleGrid from "./PeopleGrid";


// Style rules
import { Sizes } from "../../styles";

const App = ({
	blockTitle,
	blockText,
	blockButtonText,
	pageId,
	panelTitle,
	pageContent,
	peopleJson,
}) => {
	const [isStaffModalOpen, setIsStaffModalOpen] = useState(false);
	const [isBlockModalOpen, setIsBlockModalOpen] = useState(false);
	const [selectedStaffMember, setSelectedStaffMember] = useState(null);
	const [staffMembers] = useState(JSON.parse(peopleJson));
	const [pageContentId] = useState(pageId);
	const [sharingStaffModal, setSharingStaffModal] = useState(false);

	// handles the scroll behavior on open and closing of the Staff Modal and Block Modal
	useEffect(() => {
		if (isStaffModalOpen || isBlockModalOpen) {
			document.body.style.overflow = "hidden";
		} else {
			document.body.style.overflow = "scroll";
		}
	}, [isStaffModalOpen, isBlockModalOpen]);

	// useEffect responsible for displaying the staff and block modal from a sharable url
	useEffect(() => {
		if (staffMembers.length > 0 && window.location.hash) {
			// we extract the url id from the Hash
			const id = window.location.hash.match(/(\d+)/)[0];

			// we extract the url id from the Hash
			const trimmedUrl = parseInt(id);

			if (trimmedUrl) {
				// find the member we want from the staff members array using the trimmed hash
				let selectedMember = staffMembers.find(
					(member) => member.id == trimmedUrl
				);

				if (selectedMember) {
					setSharingStaffModal(true);
					toggleStaffModal(selectedMember);
				} else {
					// if the selected member is not found we extract the page id from the hash
					let trimmedValue = window.location.hash.replace("#", "");
					if (trimmedValue === pageContentId) {
						// if there is no selected member we open the block modal
						toggleBlockModal(pageContentId);
					}
				}
			}
		}
	}, [staffMembers]);

	const updateUrl = (params) => {
		let urlParams;
		if (params) {
			// we use the hash param in window.location to store the staff ID
			urlParams = "#" + params;
		}
		window.history.pushState(null, "", urlParams);
	};

	const toggleBlockModal = (pageId) => {
		if (pageId) {
			updateUrl(pageId);
		} else {
			window.history.pushState({}, "", window.location.pathname);
		}
		return setIsBlockModalOpen((currentState) => !currentState);
	};

	const toggleStaffModal = (staffMember) => {
		if (staffMember) {
			setSelectedStaffMember(staffMember);
			updateUrl(staffMember.slug);
		} else {
			setSelectedStaffMember(null);
			window.history.pushState({}, "", window.location.pathname);
			if (sharingStaffModal) {
				window.location.reload();
				setSharingStaffModal(false);
			}
		}
		return setIsStaffModalOpen((currentState) => !currentState);
	};

	return (
		
		<BlockContainer>
			<Block>
				<BlockContent>
					<BlockTitle>{blockTitle}</BlockTitle>
					{blockText && <BlockText>{blockText}</BlockText>}
				</BlockContent>
				{pageContent && blockButtonText && (
					<BlockButton
						type="button"
						aria-label={`see ${panelTitle}`}
						onClick={() => toggleBlockModal(pageId)}
						onKeyDown={(e) => {
							if (e.key === "Enter") {
								toggleBlockModal(pageId);
							}
						}}
						tabIndex="0"
					>
						{blockButtonText}
					</BlockButton>
				)}
			</Block>
			<PeopleGrid
				peopleJson={peopleJson}
				toggleStaffModal={toggleStaffModal}
				staffMembers={staffMembers}
				isStaffModalOpen={isStaffModalOpen}
				selectedStaffMember={selectedStaffMember}
				setSelectedStaffMember={setSelectedStaffMember}
			/>
		</BlockContainer>
	);
};

App.propTypes = {
	peopleJson: PropTypes.string,
	blockTitle: PropTypes.string,
	blockText: PropTypes.string,
	blockButtonText: PropTypes.string,
	pageContent: PropTypes.string,
	panelTitle: PropTypes.string,
	pageId: PropTypes.string,
};

export default App;

const BlockContainer = styled.div``;

const Block = styled.div`
	display: flex;
	flex-direction: column;
	align-items: flex-start;
	gap: 4rem;
	margin-bottom: 3rem;

	@media screen and (min-width: ${Sizes.screens.large}) {
		display: grid;
		grid-template-columns: minmax(0, 65.8rem) minmax(0, auto);
		justify-content: space-between;
		gap: unset;
		align-items: flex-end;
	}
	> a {
		width: fit-content;
		height: fit-content;

		@media screen and (min-width: ${Sizes.screens.large}) {
			margin-left: auto;
		}
	}
`;

const BlockContent = styled.div``;
const BlockTitle = styled.h2``;
const BlockText = styled.p`
	margin-top: 2rem;
`;

const BlockButton = styled.button`
	width: fit-content;
	height: fit-content;
	white-space: unset;

	@media screen and (min-width: ${Sizes.screens.large}) {
		margin-left: auto;

	}

	&::after {
		@media screen and (min-width: ${Sizes.screens.large}) {
			right: 3rem;
		}
	}
`;
